var render, staticRenderFns
import script from "./NgTable.vue?vue&type=script&lang=js&"
export * from "./NgTable.vue?vue&type=script&lang=js&"
import style0 from "./NgTable.vue?vue&type=style&index=0&id=38ca91ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca91ff",
  null
  
)

export default component.exports